import React, { useEffect, useState } from 'react'

import A4Page from '../A4Page';
import TopDetail from '../TopDetail';
import Page1 from './Page1';
import Page2 from './Page2';
import Page1Book from './Page1Book';
import Page2Book from './Page2Book';
const L60_25 = React.forwardRef(({ data, selectColor, tab }, ref) => {
  const [bookFormat, setBookFormat] = useState(false);
  // Güvenli erişim + null guard
  const rawSizes = data?.washingLabel?.[selectColor]?.sizes || [];

  // amount > 0 filtrele, her elemanı kopyala (dış mutasyonlara karşı)
  const allSizes = rawSizes
    .filter(item => (item?.amount ?? 0) > 0)
    .map(s => ({ ...s })); // referans tazelensin

  // 7'şer gruplandır (gerçekten 7 istiyorsan; 8 ise 8 yap)
  const filteredAndGroupedSizes = allSizes.reduce((acc, item, index) => {
    const groupIndex = Math.floor(index / 7);
    if (!acc[groupIndex]) acc[groupIndex] = [];
    acc[groupIndex].push(item);
    return acc;
  }, []);

  // Stabil key üretici
  const stableKey = (sizeData, groupIndex, index) =>
    sizeData?.sCode || sizeData?.id || `${groupIndex}-${index}-${sizeData?.amount}`;

  const makeBarcode = (sizeData) => {
    const [p0 = '', p1 = ''] = (data?.articleNo || '').split('/');
    const color = data?.washingLabel?.[selectColor]?.colorCode || '';
    const sCode = sizeData?.sCode || '';
    return `0${p0}${p1}${color}${sCode}`;
  };

  useEffect(() => {
    const referenceCode = data?.referance?.code || '';
    if (referenceCode.includes("BOOK FORMAT") || referenceCode.includes("BOOK")) {
      setBookFormat(true);
    }
  }, [data?.referance?.code]);

  // Veri yoksa boş dön (ilk render güvenliği)
  if (!Array.isArray(rawSizes) || rawSizes.length === 0) {
    return <div className="flex flex-col items-center" ref={ref} />;
  }

  // Book Format - Her sizeData için Page1 ve Page2 aynı sayfada
  if (bookFormat) {
    return (
      <div className="flex flex-col items-center" ref={ref}>
        {allSizes.map((sizeData, index) => (
          <A4Page key={stableKey(sizeData, 0, index)} type="dikey">
            <div className="space-y-5">
              <TopDetail values={data} selectColor={selectColor} tab={tab} />
              <div className="space-y-3">
      
                <Page2Book data={data} sizeData={sizeData} selectColor={selectColor} barcodeValue={makeBarcode(sizeData)} />
              </div>
            </div>
          </A4Page>
        ))}
      </div>
    );
  }

  // Klasik format
  return (
    <div className="flex flex-col items-center" ref={ref}>
      {filteredAndGroupedSizes.map((group, groupIndex) => (
        <A4Page key={`page-${groupIndex}`} type="dikey">
          <div className="space-y-5">
            <TopDetail values={data} selectColor={selectColor} tab={tab} />
            <div className="space-y-3">
              {group.map((sizeData, index) =>
                sizeData ? (
                  <Page1
                    key={stableKey(sizeData, groupIndex, index)}
                    selectColor={selectColor}
                    barcodeValue={makeBarcode(sizeData)}
                    data={data}
                    sizeData={sizeData}
                  />
                ) : null
              )}
            </div>
          </div>
        </A4Page>
      ))}

      {/* Page2 KALDI – değişiklik yok */}
      <A4Page type="dikey">
        <div className="space-y-5">
          <TopDetail values={data} selectColor={selectColor} tab={tab} />
          <Page2 data={data} tab={tab} />
        </div>
      </A4Page>
    </div>
  );
});

export default L60_25;
